import React, { createContext, useContext, useMemo } from 'react'
import usePeopleMergePreview from '../hooks/usePeopleMergePreview'
import usePeopleMergeReviewMutation from '../hooks/usePeopleMergeReviewMutation'
import usePeopleMergeMutation from '../hooks/usePeopleMergeMutation'
import useJobMapping from '../hooks/useJobMapping'

const PeopleMergeContext = createContext(null)

export function PeopleMergeProvider({ children }) {
  const jobMappingData = useJobMapping()
  const mergeData = usePeopleMergePreview({
    onPersonsChange: jobMappingData.resetJobMappings,
  })
  const reviewMutation = usePeopleMergeReviewMutation()
  const mergeAction = usePeopleMergeMutation()

  const contextValue = useMemo(
    () => ({
      mergeData,
      jobMappingData,
      reviewMutation,
      mergeAction,
    }),
    [mergeData, jobMappingData, reviewMutation, mergeAction],
  )

  return <PeopleMergeContext.Provider value={contextValue}>{children}</PeopleMergeContext.Provider>
}

export function usePeopleMergeContext() {
  const context = useContext(PeopleMergeContext)
  if (!context) {
    throw new Error('usePeopleMergeContext must be used within PeopleMergeProvider')
  }
  return context
}
